/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBSIGNINGOPTIONS = {
    ESigning: '1',
    InOfficeESigning: '2',
    DownloadAndSign: '3'
} as const;
export type GHUBSIGNINGOPTIONS = typeof GHUBSIGNINGOPTIONS[keyof typeof GHUBSIGNINGOPTIONS];


export function GHUBSIGNINGOPTIONSFromJSON(json: any): GHUBSIGNINGOPTIONS {
    return GHUBSIGNINGOPTIONSFromJSONTyped(json, false);
}

export function GHUBSIGNINGOPTIONSFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBSIGNINGOPTIONS {
    return json as GHUBSIGNINGOPTIONS;
}

export function GHUBSIGNINGOPTIONSToJSON(value?: GHUBSIGNINGOPTIONS | null): any {
    return value as any;
}

